import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCreateDraftError, getIsCreatingDraft } from '../selectors';
import { createDraftPpi as createDraftPpiAction } from '../actions';

const useCreateDraftVersionPpi = () => {
  const [isStarted, setIsStarted] = useState(false);
  const [isCreated, setIsCreated] = useState(false);
  const dispatch = useDispatch();
  const isCreatingDraft = useSelector(getIsCreatingDraft);
  const error = useSelector(getCreateDraftError);
  const isCreatedWithoutError = !isCreatingDraft && !error;

  if (isStarted && isCreatedWithoutError) {
    if (!isCreated) {
      setIsCreated(true);
    }
  }

  const createDraftPpi = id => {
    dispatch(createDraftPpiAction(id));
    setIsStarted(true);
  };

  return [createDraftPpi, isCreatingDraft, isCreated];
};

export default useCreateDraftVersionPpi;
